import { NotificationsModule } from "UIPalette/NotificationsModule/NotificationsModule";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";

export default function Notifications() {
  const { insetPadding } = useMobilePlatform();

  const containerHeight = insetPadding
    ? `calc(100vh - ${insetPadding.top + 80}px)`
    : "calc(100vh - 80px)";

  return (
    <div data-testid="notifications-container" className="flex flex-col" style={{ height: containerHeight }}>
      <PageTitle title="Notifications" />
      <NotificationsModule />
    </div>
  );
}
